import { createFileRoute } from '@tanstack/react-router'

import { queryKeys } from '@/api/keys'
import { notificationsApi } from '@/api/notifications'
import { NotificationSettingsForm } from '@/components/notifications/notification-settings-form'

/** Mon compte › Notifications : les catégories du portail (lot 13). */
export const Route = createFileRoute('/portal/compte/notifications')({
  component: PortalNotifications,
})

function PortalNotifications() {
  return (
    <NotificationSettingsForm
      queryKey={queryKeys.notifications.portalSettings}
      fetch={() => notificationsApi.portalSettings()}
      update={(payload) => notificationsApi.updatePortalSettings(payload)}
    />
  )
}
